import React from 'react';
import config from '../config/config';
import '../style/warning.css';

export default class PageNotFound extends React.Component {
    render() {
        let homeUrl = config.homeUrl;
        return (
            <div className="page-wrap">
                <div className="container">
                    <div className="message animated bounceIn">
                        <div className="display-table">
                            <div className="display-table-cell">
                                <svg className="icon icon-left icon-x"></svg>
                            </div>
                            <div className="display-table-cell">
                                <h1>Error 404</h1>
                                <h2>Page not Found!</h2>
                                <p>Go back to <a href={homeUrl}>Home Page</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/route/PageNotFound.js